export const additionalDict = {
    reception: [
        'тумба под экспонат',
        'экспонат',
        'плазма на стойке',
        'диван',
        'журнальный стул',
        'мягкое кресло',
        'пуф мягкий',
        'тач-стол',
        'буклетница',
        'витрина стеклянная',
    ],
    exhibit: ['тумба под экспонат', 'экспонат', 'ресепшн', 'тач-стол', 'буклетница', 'витрина стеклянная'],
    'group-1': [
        '6 стульев + стол',
        '2 дивана + журнальный столик',
        'диван + 2 кресла',
        'плазма',
        'тумба под экспонат',
        'экспонат',
        'тач-стол',
    ],
    'group-2': [
        '4 стула + стол',
        '6 стульев + стол',
        '2 дивана + журнальный столик',
        'диван + 2 кресла',
        'пуф мягкий',
        'стеклянный стол + 3 стула',
        'плазма',
        'кофейная тумба',
        'стеллаж',
    ],
    exhibitSecond: [
        'тумба под экспонат',
        'экспонат',
        'плазма на стойке',
        'диван',
        'журнальный стул',
        'мягкое кресло',
        'пуф мягкий',
        'тач-стол',
        'буклетница',
        'витрина стеклянная',
    ],
};
